export const toSnakeCase = (text) => {
  return text.trim().toLowerCase().replace(/\s+/g, "_");
}